import React, { useEffect, useState } from "react"
import type { CompetitionProps, CompetitionResultTypeProps, CompetitionTypeProps, MyPlayerProps, PlayerBalanceProps } from "../../types"
import { CompetitionHelpers } from "../api"
import moment from "moment-mini"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"
import { Image } from "react-native"

type EnterCompetitionPromptProps = {
    player?:MyPlayerProps,
    player_balance?:PlayerBalanceProps,
    competition:CompetitionProps,
    competition_type:CompetitionTypeProps,
    competition_result_type:CompetitionResultTypeProps,
    width:number,
    mode:'desktop'|'mobile',
    onVerify: () => void,
    onRequestAuthenticate:() => void,
    onCancel:() => void,
    onEnter: (promo_balance?:boolean) => void
}

const EnterCompetitionPrompt = ({ player, mode, player_balance, competition, competition_type, competition_result_type, onRequestAuthenticate, onCancel, onEnter, onVerify }:EnterCompetitionPromptProps) => {
    const C = useColors();
    const [ use_promo_balance, setUsePromoBalance ] = useState(false);
    let potential_winnings = competition.ticket_revenue
    if(competition.promo_payout){
        potential_winnings += competition.promo_payout
    }
    if(competition.guaranteed_payout){
        if(potential_winnings < parseFloat(competition.guaranteed_payout as string)){ potential_winnings = parseFloat(competition.guaranteed_payout as string) }
    }
    const isBalanceEnough = () => {
        if(!player_balance){ return false }
        let buy_in = parseFloat(competition.buy_in as string);
        switch(competition.market_type){
            case 'FREE':
                if(player_balance.free_market_balance < buy_in){ return false }
                return true
            case 'FOR_MONEY':
                if(use_promo_balance){
                    if(player_balance.promo_balance < buy_in){ return false }
                    return true
                }
                if(player_balance.balance < buy_in){ return false }
                return true
            default: return false
        }
    }
    const balance_enough = isBalanceEnough();
    
    useEffect(() => {
        if(!player){ return }
    },[])

    const requires_verification = player && parseInt(competition?.buy_in as string ?? 0) > 0 && competition?.market_type == 'FOR_MONEY' && player?.vouched_status != 'verified' ? true : false
    const cl = competition.market_type == 'FOR_MONEY'?'$':'E'
    return (
        <View float style={mode=='desktop'?{borderRadius:22, width:400 }:{ borderTopRightRadius:22, borderTopLeftRadius:22 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:22, borderTopLeftRadius:22 }}>
                <Image
                    source={{ uri: competition.image?.url }}
                    style={{ height:40, width:40, borderRadius:4 }}
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme="h1">{competition.competition_name}</Text>
                    <Text theme="description" style={{ marginTop:3 }}>{competition.competition_description}</Text>
                </View>
                <View transparent style={{ padding:10, marginRight:4, backgroundColor: CompetitionHelpers.getCompColors(competition_type.type).borderColor, borderRadius:4 }}>
                    <Text size={12} theme="h2" color={C.text.white}>{competition_type.type_label}</Text>
                </View>
            </View>
            <View transparent>
                {competition_result_type ?
                <View type='row' style={{ padding:5, paddingLeft:15, paddingRight:15 }}>
                    <Text style={{ flex:1 }} theme="h2">Payout Type</Text>
                    <Text theme="h1">{competition_result_type.label}</Text>
                </View>
                :<></>}
                {competition_type?.type == 'pick' ?
                <View type='row' style={{padding:5, paddingLeft:15, paddingRight:15}}>
                    <Text style={{ flex:1 }} theme="h2">Number of Picks</Text>
                    <Text theme="h1">{competition.max_pick_count}</Text>
                </View>
                :
                <View type='row' style={{padding:5, paddingLeft:15, paddingRight:15}}>
                    <Text style={{ flex:1 }} theme="h2">Starting Balance</Text>
                    <Text theme="h1">{competition.initial_balance}</Text>
                </View>
                }
                <View type='row' style={{padding:5, paddingLeft:15, paddingRight:15}}>
                    <Text style={{ flex:1 }} theme="h2">Available Tickets</Text>
                    <Text theme="h1">{parseFloat(competition.available_tickets as string) - competition.tickets_sold}</Text>
                </View>
                <View style={{ backgroundColor:C.views.liquidMarket }}>
                    <View transparent type='row' style={{ padding:5, paddingLeft:15, paddingRight:15}}>
                        <Text style={{ flex:1 }} theme="h2">Total Payout*</Text>
                        <Text theme="h1">{cl}{potential_winnings.toFixed()}</Text>
                    </View>
                    <Text style={{ padding:5,  paddingLeft:15, paddingRight:15 }} theme="description">* Payout is always number of entries * ticket price (We take NO FEES on competitions).  We may guarantee a minimum payout which will increase as more entries come in.</Text>
                </View>               
            </View>
            {player_balance && player_balance.promo_balance >= parseFloat(competition.buy_in as string) ?
            <Button style={{ margin:10, backgroundColor:C.text.gold, padding:10, flexDirection:'row', alignItems:'center' }} onPress={() => {
                if(use_promo_balance){
                    //Remove promo balance and open_amt
                    setUsePromoBalance(false);
                } else {
                    setUsePromoBalance(true);                    
                }
                }}>
                    <View transparent style={{ marginRight:10, height:30, width:30, borderWidth:1, borderColor:C.text.h1, justifyContent:'center', alignItems:'center' }}>
                        {use_promo_balance ?
                        <View style={{ height:20, width:20, backgroundColor:C.text.h1 }} />
                        :<></>}
                    </View>
                    <View transparent>
                        <Text size={14} theme="h1" color={C.text.white}>${player_balance?.promo_balance} Promotion Available</Text>
                        <Text style={{ marginTop:2}} color={C.text.white} theme="description">Press / Click here to use promo balance</Text>
                    </View>
                
            </Button>
            :<></>}
            <View type='footer' style={{ borderBottomRightRadius:22, borderBottomLeftRadius:22 }}>
                <View transparent style={{ flexDirection:'row', padding:10 }}>
                    <Button
                        style={{ flex:1, marginRight:3 }}
                        type='close'
                        title="Cancel"
                        onPress={() => onCancel()}
                    />
                    {requires_verification ?
                    <Button
                        style={{ flex:2, marginLeft:2 }}
                        title={`Verify My Account`}
                        type='success'
                        onPress={() => onVerify()}
                    />
                    : !player ?
                    <Button
                        style={{ flex:2, marginLeft:2 }}
                        title={`Sign In`}
                        type='success'
                        onPress={() => onRequestAuthenticate()}
                    />
                    :
                    <Button
                        style={{ flexGrow:2, marginLeft:2, opacity:balance_enough?1:0.5 }}
                        disabled={!balance_enough}
                        title={`Enter Competition${competition.buy_in == 0 ? ``:` ${cl}${competition.buy_in}`}`}
                        type='success'
                        onPress={() => onEnter(use_promo_balance)}
                    />
                    }
                </View>
                <View transparent type='row' style={{ padding:10 }}>
                    <Text style={{ flex:1 }}>Join Until</Text>
                    <Text theme="h1">{moment(competition.scheduled_datetime).format('MMM DD - hh:mm a')}</Text>
                </View>
            </View>
        </View>
    )
}

export default EnterCompetitionPrompt